import { gemmiciApiServiceClient } from "../../core/apis/gemmiciApiService/AxiosIntance";

export default {
  /* GET POST PUT DELETE post */
  createPostAPI(data) {
    return gemmiciApiServiceClient.post("posts", data);
  },
  editPostAPI(data) {
    return gemmiciApiServiceClient.put("posts", data);
  },
  deletePostAPI(nameId) {
    return gemmiciApiServiceClient.delete("posts", {
      name_id: nameId
    });
  },
  createPostPicture(payload) {
    return gemmiciApiServiceClient.post("post_picture", payload, {
      headers: {
        "Content-type": "multipart/form-data"
      }
    });
  },
  editPostPicture(payload) {
    return gemmiciApiServiceClient.put("post_picture", payload);
  },
  /* Archive Post */
  /* PATCH */
  archivePostAPI(nameId) {
    return gemmiciApiServiceClient.patch("posts/archive", {
      name_id: nameId
    });
  },
  retrievePostAPI(nameId) {
    return gemmiciApiServiceClient.get("share/post/retrieve/" + nameId);
  },
  publishPostAPI(nameId) {
    return gemmiciApiServiceClient.patch("posts/confirm", {
      name_id: nameId
    });
  },
  cancelArchivePostAPI(nameId) {
    return gemmiciApiServiceClient.patch("share/post/cancel/archive/" + nameId);
  },
  userPostListAPI() {
    return gemmiciApiServiceClient.get("posts/me");
  },
  postListAPI(username) {
    return gemmiciApiServiceClient.get("share/posts/" + username);
  }
};
